import { memo } from 'react';

import Image from 'next/image';

import { GetTripRes_stops } from '@/global-states/trip';
import imageLoader from '@/utils/image-loader';
import iconDriver from '@public/assets/icons/icon-driver.svg';

const PinIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#998818"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="mt-0.5 shrink-0 lg:h-[22px] lg:w-[22px]"
    aria-hidden
  >
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const DriverCard = ({
  userName,
  driverName,
  driverPicture,
  driverPlate,
  tripStops,
  etaSlot,
}: {
  userName?: string;
  driverName?: string;
  driverPicture?: string;
  driverPlate?: string;
  tripStops?: GetTripRes_stops[];
  etaSlot?: React.ReactNode;
}) => {
  const origin = tripStops?.find(
    (trip: GetTripRes_stops) => trip.is_origin === true
  );

  return (
    <>
      <div className="mb-4 flex items-start gap-2 lg:mb-5 lg:gap-[9px]">
        <PinIcon />
        <h1 className="text-[17px] font-extrabold leading-[1.32] tracking-[-0.01em] text-ro-black lg:text-xl lg:leading-[1.3]">
          {userName} Journey to {origin?.description}, {origin?.name}
        </h1>
      </div>

      {etaSlot}

      <div className="rounded-2xl border border-ro-border-light bg-white p-3.5 shadow-card lg:p-4">
        <div className="flex items-center justify-between gap-3">
          <div className="flex min-w-0 items-center gap-3 lg:gap-[13px]">
            <div className="relative h-12 w-12 shrink-0 overflow-hidden rounded-full bg-ro-ink shadow-avatar lg:h-[50px] lg:w-[50px]">
              <Image
                loader={imageLoader}
                src={driverPicture || iconDriver}
                alt="Driver profile"
                layout="fill"
                objectFit="cover"
                priority
              />
            </div>
            <div className="min-w-0">
              <div className="break-words text-[15.5px] font-bold leading-tight text-ro-black lg:text-base">
                {driverName}
              </div>
              <div className="mt-px text-[12.5px] font-medium text-ro-stone lg:text-[13px]">
                Driver
              </div>
            </div>
          </div>
          <div className="flex shrink-0 flex-col items-end gap-1">
            <span className="text-[10px] font-semibold tracking-[0.06em] text-ro-muted">
              VEHICLE
            </span>
            <span className="rounded-md border-[1.5px] border-ro-border bg-ro-light-bg px-2 py-0.5 text-base font-extrabold tracking-[0.04em] text-ro-black lg:px-[9px] lg:text-[17px]">
              {driverPlate}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(DriverCard);
